'use strict';

/**
 * @ngdoc function
 * @name ribytRsvpApp.controller:AboutCtrl
 * @description
 * # AboutCtrl
 * Controller of the ribytRsvpApp
 */
angular.module( 'ribytRsvpApp' )
    .controller( 'ErrorCtrl', ['$stateParams', '$scope', '$rootScope', 'messageDictionary', function ( $stateParams, $scope, $rootScope, $messageDictionary ) {
        $rootScope.bannerImage = true;
        $rootScope.isTicketPage = false;
        $rootScope.isLandingPage = false;
        if ( _.has( $stateParams, 'message' ) && $stateParams.message ) {
            $scope.message = $stateParams.message;
        } else {
            $scope.message = $messageDictionary.error.generalContactSupport;
        }
    }] );
